import { useMutation } from "@tanstack/react-query";

import { clearTokens } from "../store/tokens.store";

import { postOrionLogout } from "./orionv2/postOrionLogout";

const postLogoutUser = async () => {
  const orionData = await postOrionLogout();
  clearTokens();

  return orionData;
};

export const useLogoutUser = () => {
  return useMutation({
    mutationFn: () => postLogoutUser(),
  });
};
